import AttachmentTypeRepository from '@/shared/http/repositories/socialProject/attachment-type'
import BreadCrumb from '@/components/layout/BreadCrumb/breadCrumb.vue'
import NewRegister from '@/components/layout/NewRegister/newRegister.vue'
import AttachmentType from '@/shared/models/attachmentType'
import { IsSuccessCode } from '@/shared/utils/API'
import { loading, toast } from '@/shared/utils/UIHelper'

export default {
  name: 'EditarTipoDeAnexo',

  components: {
    [BreadCrumb.name]: BreadCrumb,
    [NewRegister.name]: NewRegister
  },

  data: () => ({
    placeholder: 'Nome',
    title: 'Tipo de Anexo',
    attachmentType: new AttachmentType(),
    isNew: false
  }),

  computed: {
    breadCrumb() {
      return {
        breadcrumbItems: [
          {
            text: 'Dashboard',
            href: this.$router.resolve({ name: 'Dashboard' }).href
          },
          {
            text: 'Tipos de Anexo',
            href: this.$router.resolve({ name: 'AttachmentType' }).href
          },
          {
            text: 'Editar tipo de anexo',
            active: true
          }
        ]
      }
    }
  },

  created() {
    this.getById()
  },

  methods: {
    getById() {
      loading.push()
      AttachmentTypeRepository.GetById(this.$route.params.id)
        .then(res => {
          if (!IsSuccessCode(res)) return Promise.reject()

          this.attachmentType = res.data.data
          loading.pop()
          return Promise.resolve()
        })
        .catch(() => {
          loading.pop()
          toast.error('Erro ao carregar tipo de anexo', 'ERRO')
        })
    },

    update(attachmentType) {
      loading.push()
      AttachmentTypeRepository.Update(attachmentType)
        .then(res => {
          if (!IsSuccessCode(res)) return Promise.reject()

          loading.pop()
          toast.success('Tipo de Anexo editado com sucesso', 'EDITAR TIPO DE ANEXO')
          Promise.resolve()
          return this.$router.replace({ name: 'AttachmentType' })
        })
        .catch(() => {
          loading.pop()
          toast.error('Erro ao editar tipo de anexo', 'ERRO')
        })
    }
  }
}
